import type { PageStructure } from '@st/document-viewer-kit'
import { ViewElementContainer } from '@st/document-viewer-kit'
import type { ElementStatus, ToolMessage } from '@st/document-viewer-kit/plugins/annotations'
import type { StampAnnotation } from '@st/sdk'
import { DocumentAnnotationDisplay } from '~/st-doc-viewer/document-annotation-display'
import type { SignOffsToolState } from '../../annotations'

export function SignOffAnnotationElement({
  annotation
}: {
  annotation: StampAnnotation
  page: PageStructure
  status: ElementStatus
  send: (message: ToolMessage<StampAnnotation, SignOffsToolState>) => void
}) {
  return (
    <ViewElementContainer key={annotation.id} bounds={annotation.bounds}>
      <DocumentAnnotationDisplay annotation={annotation} />
    </ViewElementContainer>
  )
}
